var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 12V11.2235C10.1 10.1364 10.1 9.59279 9.88746 9.17755C9.70051 8.81229 9.4022 8.51533 9.03528 8.32922C8.61815 8.11765 8.0721 8.11765 6.98 8.11765H4.12C3.0279 8.11765 2.48185 8.11765 2.06472 8.32922C1.6978 8.51533 1.39949 8.81229 1.21254 9.17755C1 9.59279 1 10.1364 1 11.2235V12M10.1 2.29412L11.4 3.58824L14 1M7.825 3.26471C7.825 4.51547 6.80645 5.52941 5.55 5.52941C4.29355 5.52941 3.275 4.51547 3.275 3.26471C3.275 2.01394 4.29355 1 5.55 1C6.80645 1 7.825 2.01394 7.825 3.26471Z",
    stroke: "#5C6D7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHands);
export default __webpack_public_path__ + "static/media/check-hands.0bb553d823737ff09db7e05192042478.svg";
export { ForwardRef as ReactComponent };